import { MarketItemSkeleton } from '../market-item';
import { TextTooltip } from '../text-tooltip';
import { Button } from '../ui/button';
import { UploadedImage } from '../uploaded-image';
import { ViewUserIcon } from '@/client/assets';
import { useModelStore } from '@/client/store/model-store';
import useSearchStore from '@/client/store/search-store';
import { api } from '@/client/utils/api';
import { useEvents } from '@/libs/react-sdk/api/use-events';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';

export const SearchRecommend = ({ setInput }: { setInput: (input: string) => void }) => {
  const { t } = useTranslation();
  const [, navigate] = useLocation();
  const setSearchOpen = useModelStore(state => state.setSearchOpen);
  const searchList = useSearchStore(state => state.searchList);
  const clearSearch = useSearchStore(state => state.clearSearch);
  const pageSize = searchList.length > 0 ? 7 : 9;
  const eventsQuery = useEvents(api, { page: 1, pageSize });
  const eventList = useMemo(
    () => eventsQuery.data?.events ?? [],
    [eventsQuery.data?.events]
  );
  return (
    <div className="space-y-3 md:space-y-6">
      {/* history */}
      {searchList.length > 0 && (
        <div className="space-y-2">
          <div className="flex items-center space-x-2 text-xs">
            <h3 className="leading-3 text-foreground/70 pl-2">{t('recent-searches')}</h3>
            <span className="text-foreground/40 hover:text-foreground cursor-pointer" onClick={() => clearSearch()}>
              {t('clear')}
            </span>
          </div>
          <div className="w-full flex flex-wrap gap-2 items-center max-h-20 overflow-y-auto">
            {searchList.map((item, index) => (
              <Button
                key={`search-${item}-${index}`}
                size="sm"
                variant="outline"
                className="bg-foreground/5 rounded-full px-3 border-foreground/4 shadow-none"
                onClick={() => setInput(item)}
              >
                {item}
              </Button>
            ))}
          </div>
        </div>
      )}
      <div className="space-y-2">
        <h3 className="text-3 leading-3 text-foreground/70 pl-2">{t('trending-labe')}</h3>
        <div className="w-full">
          {eventList.map(item => {
            const totalParticipants = item.markets?.reduce((sum, m) => sum + (m.participantsCount || 0), 0) ?? 0;
            const picUrl = item.picUrl || item.markets?.[0]?.picUrl || '';
            return (
              <div
                key={`event-${item.id}`}
                onClick={() => {
                  setSearchOpen(false);
                  navigate(`/event/${item.eventId}`);
                }}
                className="p-2 space-x-3 min-h-12 flex items-center justify-between hover:bg-foreground/5 rounded-md cursor-pointer"
              >
                <UploadedImage fileKey={picUrl} className="size-8 rounded-2" />
                <TextTooltip tooltip={item.title} className="flex-1 line-clamp-3">
                  {item.title}
                </TextTooltip>
                <div className="space-x-1 flex items-center text-3 flex-shrink-0">
                  <ViewUserIcon className="size-3 fill-foreground/70" />
                  <span className="text-foreground/70">{totalParticipants}</span>
                </div>
              </div>
            );
          })}
          {eventsQuery.isLoading && <MarketItemSkeleton />}
        </div>
      </div>
    </div>
  );
};
